import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberInputDirective } from './number-input.directive';
import { NumberInputComponent } from './number-input.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    NumberInputDirective,
    NumberInputComponent,
  ],
  exports: [
    NumberInputDirective,
    NumberInputComponent,
  ],
})
export class NumberInputModule { }



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/number-input/number-input.module.ts